<lib-input-wrapper [ionItemWrap]="ionItemWrap">
    <div [formGroup]="form">
        <ion-textarea
            labelPlacement="stacked"
            [label]="hideLabel ? '' : label"
            [required]="required"
            class="input input-textarea"
            [rows]="rows"
            [formControlName]="controlName"
            [placeholder]="placeholder"
            [ngClass]="{
                'has-error': (submitAttempt && !formInput?.valid) || errorText
            }"
            [helperText]="helperText"
            [errorText]="errorText"
            [autoGrow]="autoGrow" />

        <div *ngIf="formInput && formInput.errors && submitAttempt">
            <p *ngIf="formInput.errors['required']" class="invalid-text">Required field</p>
            <p *ngIf="!formInput.errors['required']" class="invalid-text">Please check this field again</p>
        </div>

        <ng-content select="[formMessages]"></ng-content>

        <div class="invalid-text">
            <ng-content select="[formErrorMessages]"></ng-content>
        </div>
    </div>
</lib-input-wrapper>
